// Shared time formatting for deck displays (00:00 zero-padded).
export const fmtTs = (s) => {
  if (s == null || Number.isNaN(s)) return '00:00';
  const m = Math.floor(s / 60);
  const r = Math.floor(s % 60);
  return `${m.toString().padStart(2, '0')}:${r.toString().padStart(2, '0')}`;
};
